import {createPageableParams} from "@/modules/core/services/table-utils";
import WrapperService from "@/modules/core/services/wrapper-service";

const API_URL = process.env.VUE_APP_ROOT_API + "/api/v1/dashboard/process"

const sortProcessInfoTableFields = ["name"];
const sortProcessInfoDatabaseFields = ["processName"];

const sortFinishedTableFields = ["name", "formattedDate", "checkbox"];
const sortFinishedDatabaseFields = ["processName", "date", "status"];

const sortInvitationTableFields = ["link"];
const sortInvitationDatabaseFields = ["facilityName"];

const serviceName = "DashboardWorker-Service: ";

export default class DashboardWorkerService {

  static async readAllPageableInvalidProcessInfo(page, size, search, sort, sortAsc, successF, errorF) {
    let params = createPageableParams(page, size, search, sort, sortAsc, sortProcessInfoTableFields, sortProcessInfoDatabaseFields);
    await WrapperService.get(API_URL + "/assigned/invalid", { params: params }, serviceName, successF, errorF);
  }

  static async readAllPageableProcessInfo(page, size, search, sort, sortAsc, successF, errorF) {
    let params = createPageableParams(page, size, search, sort, sortAsc, sortProcessInfoTableFields, sortProcessInfoDatabaseFields);
    await WrapperService.get(API_URL + "/assigned", { params: params }, serviceName, successF, errorF);
  }

  static async readAllPageableUrgentProcessInfo(page, size, search, sort, sortAsc, successF, errorF) {
    let params = createPageableParams(page, size, search, sort, sortAsc, sortProcessInfoTableFields, sortProcessInfoDatabaseFields);
    await WrapperService.get(API_URL + "/assigned/urgent", { params: params }, serviceName, successF, errorF);
  }

  static async readAllPageableFinishedProcesses(page, size, search, sort, sortAsc, successF, errorF) {
    let params = createPageableParams(page, size, search, sort, sortAsc, sortFinishedTableFields, sortFinishedDatabaseFields);
    await WrapperService.get(API_URL + "/result", { params: params }, serviceName, successF, errorF);
  }

  static async readAllPageableProcessInvitations(page, size, search, sort, sortAsc, successF, errorF) {
    let params = createPageableParams(page, size, search, sort, sortAsc, sortInvitationTableFields, sortInvitationDatabaseFields);
    await WrapperService.get(API_URL + "/invitation", { params: params }, serviceName, successF, errorF);
  }
}
